import EventEmitter from 'events'

import { gsap } from 'gsap/all'
import {shredText} from './utils'

// import { backfaceFixed } from './backfaceFixed'

export default class Drawr extends EventEmitter {
  constructor() {
    super()

    this.DOM = {
      rootElement: document.documentElement,
      openButton: document.querySelector('.js-openDrawer'),
      drawerArea: document.querySelector('.js-drawerArea'),
      scrollableTarget: document.querySelector('.js-drawerArea .js-scrollable'),
      nav: document.querySelectorAll('.drawerMenu a'),
    }

    this.DOM.nav.forEach((el) => {
      shredText(el);
    })

    this.state = {
      drawerOpen: false,
      touchY: false,
    }

    this.scrollLockModifier = 'is-drawerOpen'

    if (this.DOM.openButton) {
      this.DOM.openButton.addEventListener(
        'click',
        () => this.onClickButton(),
        false
      )
      this.DOM.nav.forEach((el) => {
        el.addEventListener(
          'click',
          () => this.onClickButton(),
          false
        )
      })
    }
    this.DOM.drawerArea.addEventListener(
      'transitionend',
      e => this.onTransitionendDrawer(e),
      false
    )

    this.DOM.scrollableTarget.addEventListener(
      'touchstart',
      e => this.onTouchStart(e),
      false
    )
    this.DOM.scrollableTarget.addEventListener(
      'touchmove',
      e => this.onTouchMove(e),
      false
    )
  }

  openDrawer() {
    this.changeState(true)
    this.openAnimation()
    this.emit('open')
  }
  closeDrawer() {
    this.changeState(false)
    this.emit('close')
  }
  changeState(state) {
    if (state === this.state.drawerOpen) {
      // console.log('2回以上連続で同じ状態に変更しようとしました');
      return
    }
    this.changeAriaExpanded(state)
    this.state.drawerOpen = state
  }
  changeAriaExpanded(state) {
    const value = state ? 'true' : 'false'
    this.DOM.drawerArea.setAttribute('aria-expanded', value)
    this.DOM.openButton.setAttribute('aria-expanded', value)
  }
  onClickCloseButton() {
    this.closeDrawer()
  }
  onClickButton() {
    if (this.state.drawerOpen) {
      this.closeDrawer()
    } else {
      this.activateScrollLock()
      this.openDrawer()
    }
  }
  activateScrollLock() {
    // backfaceFixed(true)
    this.DOM.rootElement.classList.add(this.scrollLockModifier)
  }
  deactivateScrollLock() {
    // backfaceFixed(false)
    this.DOM.rootElement.classList.remove(this.scrollLockModifier)
  }
  onTransitionendDrawer(e) {
    if (e.target !== this.DOM.drawerArea || e.propertyName !== 'visibility') {
      return
    }
    if (!this.state.drawerOpen) {
      this.deactivateScrollLock()
    }
  }
  onTouchStart(e) {
    if (e.targetTouches.length > 1) {
      return
    }
    this.state.touchY = e.targetTouches[0].clientY
  }
  onTouchMove(e) {
    if (e.targetTouches.length > 1) {
      return
    }
    // touchstart時と現在の差分から、スクロール方向を得る
    // 正：上方向へスクロール
    // 負：下方向へスクロール
    const touchMoveDiff = e.targetTouches[0].clientY - this.state.touchY
    if (this.DOM.scrollableTarget.scrollTop === 0 && touchMoveDiff > 0) {
      if (e.cancelable) {
        e.preventDefault()
      }
      return
    }
    if (
      this.targetTotallyScrolled(this.DOM.scrollableTarget) &&
      touchMoveDiff < 0
    ) {
      if (e.cancelable) {
        e.preventDefault()
      }
      return
    }
  }
  targetTotallyScrolled(element) {
    return element.scrollHeight - element.scrollTop <= element.clientHeight
  }
  openAnimation() {
    // this.DOM.nav.forEach((el) => {
    //   gsap.fromTo(el.querySelectorAll('span'), {
    //     clipPath: 'inset(100% 100% 100% 0%)',
    //   }, {
    //     duration: 0.9,
    //     clipPath: 'inset(0% 0% 0% 0%)',
    //     ease: 'power2.inOut',
    //     stagger: {
    //       amount: 0.6,
    //     },
    //     onComplete: () => {
    //       el.querySelectorAll('span').forEach((el) => {
    //         el.style.clipPath = 'none';
    //       })
    //     }
    //   })
    // })

  }
}
